// removed by extract-text-webpack-plugin
module.exports = {"Note":"Note__3Us_U"};